export default "__VITE_ASSET__f_fRl$Kv__"